import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { localApi, inshaApi } from "utils/imgApi";
import { catApi } from "utils/imgApi";
import { parentListApi } from "views/Pages/Parent.js"
import axios from "axios";
import AddIcon from "@material-ui/icons/Add";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import style from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styleCheck from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";

import { credentials } from "utils/imgApi";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleSweet = makeStyles(styleSweet);
const useStyCheck = makeStyles(styleCheck);

export default function AddCategorySize(props) {
  const [items, setItems] = React.useState([]);
  const [items1, setItems1] = React.useState([]);
  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [simpleSelectErr, setSimpleSelectErr] = React.useState("");
  const [categorySizeName, setCategorySizeName] = React.useState("");
  const [categorySizeNameErr, setCategorySizeNameErr] = React.useState("");
  const [getId, setGetId] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [newCategorySize, setNewCategorySize] = React.useState(false);
  const [btn, setBtn] = React.useState(false);
  const [active, setActive] = React.useState(false);
  const firstRender = useRef(true);
  const [multipleSelect, setMultipleSelect] = React.useState([]);
  const [newDefCategorySize, setDefNewCategorySize] = React.useState(false);
  const [multipleSelectErr, setMultipleSelectErr] = React.useState("");

  const classes = useStyles();
  const classe = useStyle();
  const classSweet = useStyleSweet();
  const classCheck = useStyCheck();

  const adminObj = JSON.parse(sessionStorage.getItem("sessionData"));

  async function getCat() {
    const api = localApi + `/category/list/byAdminId/${adminObj.id}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    setItems(getResult);
  }

  useEffect(() => {
    getCat();
    // catApi().then((res) => setItems(res));
    // console.log(parentListApi);

  }, []);

  const handleSimple = async (event) => {
    // setSimpleSelect(event.target.value);
    const { value } = event.target;
    const item = items.find((item) => item.id == value);
    setSimpleSelect(value);
    setGetId(item.id);
    // console.log(item)
    setSimpleSelectErr("");

    const categoryApi =
      inshaApi +
      `/category/list/byAdminId/2`;
    const categoryRresult = await fetch(categoryApi);
    const getAllCategory = await categoryRresult.json();
    // console.log(getAllCategory);

    const filteredData = getAllCategory.filter(
      (cat) => cat.title?.trim().toLowerCase() === item.title?.trim().toLowerCase()
    )[0];
    // console.log(filteredData);

    const parentApi =
      inshaApi +
      `/parent/list/byCategoryId/${filteredData.id}`;
    const parentRresult = await fetch(parentApi);
    const getAllParent = await parentRresult.json();

    // const parentOnly = filteredData && filteredData.parent.map(({ child, ...rest }) => rest).sort((a, b) => a.id - b.id);
    // console.log("PP", parentOnly);
    setItems1(getAllParent);

  };

  const handleMultiple = event => {
    setMultipleSelect(event.target.value);
    setMultipleSelectErr("")
  };

  const SubmitAddCategorySize = (e) => {
    setNewCategorySize(true);
    let errorCount = 0;
    if (simpleSelect === "" || !simpleSelect) {
      errorCount++;
      setSimpleSelectErr("Select Category");
    }
    if (categorySizeName === "" || !categorySizeName) {
      errorCount++;
      setCategorySizeNameErr("Select Product Size MM");
    }
    if (errorCount === 0) {
      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify({
          title: categorySizeName.trim(),
        }),
      };

      fetch(localApi + `/parent/add/ByCategoryId/${getId}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          if (data.error == true) {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          } else {
            alertTypeOps("danger");
            alertMsgOps("Already Exits");
            setSubmitted(true);
          }
        });
    }
  };

  const SubmitAddDefaultCategorySize = (e) => {
    setDefNewCategorySize(true);
    let errorCount = 0;
    if (simpleSelect === "" || !simpleSelect) {
      errorCount++;
      setSimpleSelectErr("Select Category");
    }
    if (!Array.isArray(multipleSelect) || multipleSelect.length < 2) {
      errorCount++;
      setMultipleSelectErr("Select at least two product sizes (MM)");
    }
    if (errorCount === 0) {
      // console.log(simpleSelect);
      // console.log(multipleSelect);
      // console.log(getId);

      const formatted = multipleSelect.map(value => ({ title: value.trim() }));

      // console.log(formatted);

      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify(formatted),
      };

      fetch(localApi + `/parent/addAll/ByCategoryId/${getId}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Inserted Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          } else {
            alertTypeOps("danger");
            alertMsgOps("Already Exits");
            setSubmitted(true);
          }
        });
    }
  }

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false; // skip first render
      return;
    }
    // console.log("Value Changed")
    setActive(false);
    // setSimpleSelect1("");
    setMultipleSelect([]);
  }, [simpleSelect]);

  return (
    <div>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <AddIcon />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Add Product Size-MM</small>
                {/* {newCategorySize === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {simpleSelectErr || categorySizeNameErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Select Category
                  </small>
                )} */}
                {active === true ? newDefCategorySize === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {simpleSelectErr || multipleSelectErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Select Category
                  </small>
                ) : newCategorySize === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {simpleSelectErr || categorySizeNameErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Select Category
                  </small>
                )}
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >
                    Added Product Size MM
                  </SweetAlert>
                ) : null}{" "}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classe.selectFormControl}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classe.selectLabel}
                    >
                      Select Category Name...
                    </InputLabel>

                    <Select
                      MenuProps={{
                        className: classe.selectMenu,
                      }}
                      classes={{
                        select: classe.select,
                      }}
                      value={simpleSelect}
                      onChange={handleSimple}
                      inputProps={{
                        name: "simpleSelect",
                        id: "simple-select",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classe.selectMenuItem,
                        }}
                      >
                        Select Category Name...
                      </MenuItem>
                      {items &&
                        items.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id}
                            classes={{
                              root: classe.selectMenuItem,
                              selected: classe.selectMenuItemSelected,
                            }}
                          >
                            {item.title}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>
                {active === false ?
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Product Size-MM"
                      id="categorySizeName"
                      inputProps={{
                        placeholder: "Ex. Product Size-MM ...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="categorySizeName"
                      value={categorySizeName}
                      onChange={(e) => {
                        setCategorySizeName(e.target.value);
                        setCategorySizeNameErr("");
                      }}
                    />
                  </GridItem> : ""}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControlLabel
                    classes={{
                      root: classCheck.checkboxLabelControl,
                      label: classCheck.checkboxLabel,
                    }}
                    control={
                      <Checkbox
                        id="active"
                        value={active}
                        checked={
                          active & (active === true) ? active : active
                        }
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setActive(checked);
                          if (!checked) {
                            // If checkbox is unchecked, clear multipleSelect
                            setMultipleSelect([]);
                            setMultipleSelectErr(""); // Also clear any errors if needed
                          }
                        }}
                        tabIndex={-1}
                        checkedIcon={
                          <Check className={classCheck.checkedIcon} />
                        }
                        icon={
                          <Check className={classCheck.uncheckedIcon} />
                        }
                        classes={{
                          checked: classCheck.checked,
                          root: classCheck.checkRoot,
                        }}
                      />
                    }
                    label={
                      <span style={{ color: "#9c27b0" }}>
                        Would you like to save the default Size-MM?
                      </span>
                    }
                  />
                </GridItem>
                {active === true ?
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl
                      fullWidth
                      className={classe.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="multiple-select"
                        className={classe.selectLabel}
                      >
                        Select Bangles Size-MM...
                      </InputLabel>
                      <Select
                        multiple
                        value={multipleSelect}
                        onChange={handleMultiple}
                        MenuProps={{ className: classe.selectMenu }}
                        classes={{ select: classe.select }}
                        inputProps={{
                          name: "multipleSelect",
                          id: "multiple-select"
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classe.selectMenuItem
                          }}
                        >
                          Select Bangles Size-MM...
                        </MenuItem>
                        {/* <MenuItem
                          classes={{
                            root: classe.selectMenuItem,
                            selected: classe.selectMenuItemSelectedMultiple
                          }}
                          value="2"
                        >
                          Paris
                        </MenuItem> */}
                        {items1 &&
                          items1.map((item1) => (
                            <MenuItem
                              key={item1.id}
                              value={item1.title}
                              classes={{
                                root: classe.selectMenuItem,
                                selected: classe.selectMenuItemSelectedMultiple,
                              }}
                            >
                              {item1.title}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                  : ""}
              </GridContainer>
              {/* <Button
                color="rose"
                onClick={SubmitAddCategorySize}
                className={classes.updateProfileButton}
              >
                Save
              </Button> */}
              {btn === true ? (
                <Button className={classes.updateProfileButton}>Save</Button>
              ) : (
                active === true ? (
                  <Button
                    color="rose"
                    onClick={SubmitAddDefaultCategorySize}
                    className={classes.updateProfileButton}
                  >
                    Save Default
                  </Button>
                ) : (
                  <Button
                    color="rose"
                    onClick={SubmitAddCategorySize}
                    className={classes.updateProfileButton}
                  >
                    Save
                  </Button>
                )
              )}

            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

AddCategorySize.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
